import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_OurFeatures = _resolveComponent("OurFeatures")!
  const _component_CompanyIntroduction = _resolveComponent("CompanyIntroduction")!
  const _component_BestServices = _resolveComponent("BestServices")!
  const _component_OurDepartment = _resolveComponent("OurDepartment")!
  const _component_GalleryExhibition = _resolveComponent("GalleryExhibition")!
  const _component_OurPricing = _resolveComponent("OurPricing")!
  const _component_PeopleAlsoAsk = _resolveComponent("PeopleAlsoAsk")!
  const _component_OurDoctors = _resolveComponent("OurDoctors")!
  const _component_OurTestimonials = _resolveComponent("OurTestimonials")!
  const _component_CallToAction = _resolveComponent("CallToAction")!
  const _component_LatestNews = _resolveComponent("LatestNews")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['header-wrap style3', { sticky: _ctx.isSticky }])
    }, [
      _createVNode(_component_MainNavbar)
    ], 2),
    _createVNode(_component_MainBanner),
    _createVNode(_component_OurFeatures),
    _createVNode(_component_CompanyIntroduction),
    _createVNode(_component_BestServices),
    _createVNode(_component_OurDepartment),
    _createVNode(_component_GalleryExhibition),
    _createVNode(_component_OurPricing),
    _createVNode(_component_PeopleAlsoAsk),
    _createVNode(_component_OurDoctors),
    _createVNode(_component_OurTestimonials),
    _createVNode(_component_CallToAction),
    _createVNode(_component_LatestNews),
    _createVNode(_component_MainFooter)
  ]))
}